import { TopicInfo } from './TopicListItemView.sync'
import htmlParser from '../utils/htmlParser'

const isAbsoluteUrl = (imgUrl: string) => imgUrl.indexOf('://') > 0

const isContainingCdn = (imgUrl: string, attachmentCdn: string) => imgUrl.includes(attachmentCdn)

export const getImageUrl = (img: string, width: string, attachmentCdn: string) => {
  const isAbsoluteImgUrl = isAbsoluteUrl(img)
  const isImgUrlContainingCdn = isContainingCdn(img, attachmentCdn)

  if (isAbsoluteImgUrl && !isImgUrlContainingCdn) {
    return img
  }

  if (isAbsoluteImgUrl && isImgUrlContainingCdn) {
    img = img.replace(attachmentCdn, '')
  }

  return attachmentCdn + 'width/' + width + '/' + img
}

interface TopicContentProps {
  topic: TopicInfo
}

const TopicContent = ({ topic }: TopicContentProps) => {
  const trimmedContent = htmlParser.stripHtml(topic.relevantPost.content.trim()).substr(0, 1000)

  return topic.featuredImage
    ? (<div class='thread-list-block__article-wrapper'>
      <div class='thread-list-block__article-excerpt'>
        <p class={'thread-list-block__content' + (topic.featuredImage ? ' thread-list-block__content--article' : '') + ' qa-topic-content'}>
          <a href={topic.url}>{trimmedContent}</a>
        </p>
      </div>
    </div>)
    : (<p class='thread-list-block__content qa-topic-content'>
      <a href={topic.url}>{trimmedContent}</a>
    </p>)
}

export default TopicContent
